import { useColumnsInstalacionesOT } from "@/erp/tecnico/orden-trabajo/shared/hooks"
import { EstadosActivacionInstallOTEnumChoice, EstadosOrdenTrabajoEnumChoice, gridSizeMdLg12, ROUTER_PATHS, TipoEntidadOrdenServicioEnumChoice, useTableFilter, useTableServerSideFiltering } from "@/shared"
import { useFetchOrdenTrabajos } from "@/shared/actions/erp"
import { GeneralTable } from "@/shared/components/ui"
import { OrdenTrabajo } from "@/shared/interfaces"
import { Grid } from "@mui/material"
import { useNavigate } from "react-router-dom"

export type ActivacionVisitaPageProps = {
    estadoOT?: EstadosOrdenTrabajoEnumChoice,
    estadoActivacion?: EstadosActivacionInstallOTEnumChoice,
    enableEdit?: boolean,
    requiereCambioOnt?:boolean
}
//const returnUrlActivacionesVisita = ROUTER_PATHS.activaciones.activacionesVisitaNav;

export default function ActivacionesVisitaPage({
    estadoActivacion,
    estadoOT,
    requiereCambioOnt,
    enableEdit
}: ActivacionVisitaPageProps) {
    const navigate = useNavigate()

    const {
        pagination,
        setPagination
    } = useTableFilter()

    const {
        pageIndex,
        pageSize
    } = pagination

    const {
        columnFilters,
        setColumnFilters
    } = useTableServerSideFiltering();
    //**fetch data 
    const {
        data,
        isLoading,
        isRefetching
    } = useFetchOrdenTrabajos({
        enabled: true,
        params: {
            page: pageIndex + 1,
            page_size: pageSize,
            estado_orden_trabajo: estadoOT,
            estado_activacion: estadoActivacion,
            tipo_orden_trabajo: TipoEntidadOrdenServicioEnumChoice.VISITA,
            requiere_cambio_ont:requiereCambioOnt
        }
    })
    //hook
    const {
        visitaActivacionColumns
    } = useColumnsInstalacionesOT()

    const onEdit = (value: OrdenTrabajo) => {
        const baseUrl = ROUTER_PATHS.activaciones.activacionesVisitaNav;
        if(estadoOT == EstadosOrdenTrabajoEnumChoice.EN_ESPERA ||
            estadoOT == EstadosOrdenTrabajoEnumChoice.ESPERA_RECOORDINADA ||
            estadoActivacion !== EstadosActivacionInstallOTEnumChoice.GESTIONADA
        ){
            navigate(`${baseUrl}/pendiente/${value.id_orden_trabajo}`)
        }else{
            navigate(`${baseUrl}/gestionada/${value.id_orden_trabajo}`)
        }
    }
    return (
        <Grid container spacing={2}>
            <Grid item {...gridSizeMdLg12}>
                <GeneralTable
                    columns={visitaActivacionColumns}
                    data={data?.data?.data || []}
                    isLoading={isLoading}
                    isRefetching={isRefetching}
                    enableManualFiltering={true}
                    //filter-server side
                    columnFilters={columnFilters}
                    onColumnFiltersChange={setColumnFilters}
                    // //
                    pagination={pagination}
                    onPaging={setPagination}
                    rowCount={data?.data.count}
                    // edit
                    canEdit={enableEdit}
                    onEdit={onEdit}
                    canDelete={false}
                />
            </Grid>
        </Grid>

    )
}